import ForgotPasswordForm from "../../components/Auth/ForgotPasswordForm";

export default function ForgotPasswordPage() {
	return <ForgotPasswordForm />;
}